import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import {
  ApplicationInsights,
  ITelemetryItem,
} from "@microsoft/applicationinsights-web";

class AppInsightsService {
  private static instance: AppInsightsService;
  private _reactPlugin: ReactPlugin;
  private _appInsights: ApplicationInsights;

  private constructor(connectionString: string) {
    this._reactPlugin = new ReactPlugin();
    this._appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: process.env.INSTRUMENTATION_KEY,
        connectionString,
        extensions: [this._reactPlugin],
        enableAutoRouteTracking: true,
        disableAjaxTracking: false,
        autoTrackPageVisitTime: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
      },
    });
    this._appInsights.loadAppInsights();

    this._appInsights.addTelemetryInitializer((env: ITelemetryItem) => {
      env.tags = env.tags || {};
      env.tags["ai.cloud.role"] = "search-ui";
      env.data = env.data || {};
      env.data["ms-appName"] = "Search";
    });
  }

  public static getInstance(connectionString: string): AppInsightsService {
    if (!AppInsightsService.instance) {
      AppInsightsService.instance = new AppInsightsService(connectionString);
    }
    return AppInsightsService.instance;
  }

  public get reactPlugin(): ReactPlugin {
    return this._reactPlugin;
  }

  public get appInsights(): ApplicationInsights {
    return this._appInsights;
  }
}

export default AppInsightsService;
